import React, { createContext, useCallback, useContext, useState } from "react";

type AssistantContextValue = {
  selectedExpenseIds: string[];
  toggleExpense: (id: string) => void;
  clearSelection: () => void;
  setSelectedExpenseIds: (ids: string[]) => void;
};

const AssistantContext = createContext<AssistantContextValue | null>(null);

export function AssistantProvider({ children }: { children: React.ReactNode }) {
  const [selectedExpenseIds, setSelectedExpenseIds] = useState<string[]>([]);

  const toggleExpense = useCallback((id: string) => {
    setSelectedExpenseIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  }, []);

  const clearSelection = useCallback(() => setSelectedExpenseIds([]), []);

  return (
    <AssistantContext.Provider
      value={{ selectedExpenseIds, toggleExpense, clearSelection, setSelectedExpenseIds }}
    >
      {children}
    </AssistantContext.Provider>
  );
}

export function useAssistant() {
  const ctx = useContext(AssistantContext);
  if (!ctx) {
    throw new Error("useAssistant debe usarse dentro de AssistantProvider");
  }
  return ctx;
}
